<template>
<div>
<div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>
<div v-else>
    <div v-for="(review, index) in reviews" :key="index" class="py-3 border-bottom">
        <div><review-stars-color :stars="review.stars" :color="getColor(review.stars)"></review-stars-color></div>
        <div class="my-1"><b>{{review.name}}</b> &bull; {{formatDateShort(review.review_date)}} <span class="purchase" v-if="review.days > 0">{{review.days}} {{review.days === 1 ? 'day' : 'days'}} after purchase</span></div>
        <pre class="mb-0"><div v-html="review.comment" v-linkified></div></pre>
    </div>
</div>
</div>
</template>

<script>
import { EventBus } from '../bus';
export default {
    props: ['product_id'],

    data() {
    return {
        reviews: [],
        loading: false,
    };
    },

    created() {
        this.getReviews();

        EventBus.$on('update-reviews', (stars) => {
            this.getReviews(stars);
        });

        EventBus.$on('reset-reviews', () => {
            this.getReviews();
        });
    },

    methods: {
        getColor(stars) {
            if (stars >= 5) { return '#00a93b'; } 
            else if (stars >= 4) { return '#96d900'; } 
            else if (stars >= 3) { return '#fae700'; } 
            else if (stars >= 2) { return '#ffa200'; } 
            else { return '#ff1800'; }
        },

        getReviews(stars = null) {

            this.loading = true;

            axios.post(`/reviews/${this.product_id}`, { stars: stars }).
            then((response) => {
                this.reviews = response.data.data;
                this.loading = false;
            });

        },
    }
};
</script>

<style scoped>
.purchase {
    font-size:0.8rem;
    color:#666;
    font-style: italic;
    margin-left:0.5rem;
}
</style>
